<template>
  <v-container class="fill-height text-start" style="opacity: 0.94" fluid>
    <v-sheet elevation="1" rounded width="100%" class="mt-16 mb-8">
      <deprecation-banner />
      <v-toolbar flat>
        <v-toolbar-title>Birth Flower Bouquet</v-toolbar-title>
      </v-toolbar>

      <v-row class="py-5 px-4">
        <v-col cols="12" md="6">
          <v-form @submit.prevent="generateBouquet">
            <v-text-field
              v-model="filename"
              label="Filename"
              outlined
              hint="Output SVG filename"
              persistent-hint
              class="mb-4"
            />

            <v-subheader class="px-0">Months</v-subheader>
            <v-row dense>
              <v-col v-for="month in months" :key="month.value" cols="6" sm="4" md="3">
                <v-checkbox
                  v-model="selectedMonths"
                  :label="month.label"
                  :value="month.value"
                  hide-details
                  dense
                />
              </v-col>
            </v-row>

            <v-switch
              v-model="autoLayout"
              label="Auto layout"
              class="mt-4"
              hide-details
            />
            <v-switch
              v-model="showGuides"
              label="Show guides"
              class="mt-2"
              hide-details
            />

            <v-btn
              type="submit"
              color="primary"
              class="mt-6"
              :loading="loading"
              :disabled="!selectedMonths.length"
            >
              Generate bouquet
            </v-btn>
          </v-form>
        </v-col>

        <v-col cols="12" md="6" class="d-flex justify-center">
          <SvgPreviewWithDownload
            :key="previewKey"
            label="Preview"
            :src="svgUrl"
            :download-filename="svgDownloadFilename"
            placeholder-text="Generated bouquet will appear here"
            placeholder-hint="Select months and click Generate bouquet"
            :preview-width="320"
          />
        </v-col>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
  import { createFlowerBouquetSvg } from '../services/pdfGenerationService'
  import SvgPreviewWithDownload from '../components/EngravingGenerator/BacksideEngraving/SvgPreviewWithDownload.vue'
  import DeprecationBanner from '../components/DeprecationBanner.vue'

  const MONTHS = [
    { value: 'jan', label: 'January' },
    { value: 'feb', label: 'February' },
    { value: 'mar', label: 'March' },
    { value: 'apr', label: 'April' },
    { value: 'may', label: 'May' },
    { value: 'jun', label: 'June' },
    { value: 'jul', label: 'July' },
    { value: 'aug', label: 'August' },
    { value: 'sep', label: 'September' },
    { value: 'oct', label: 'October' },
    { value: 'nov', label: 'November' },
    { value: 'dec', label: 'December' },
  ]

  export default {
    name: 'MizodiaBirthFlowerBouquet',
    components: { SvgPreviewWithDownload, DeprecationBanner },
    data() {
      return {
        months: MONTHS,
        selectedMonths: [],
        autoLayout: true,
        showGuides: false,
        filename: 'birth-flower-bouquet.svg',
        loading: false,
        previewKey: 0,
        svgUrl: null,
        svgDownloadFilename: null,
      }
    },
    methods: {
      withCacheBuster(url) {
        const separator = url.includes('?') ? '&' : '?'
        return `${url}${separator}t=${Date.now()}`
      },
      async generateBouquet() {
        if (!this.selectedMonths.length) return

        this.loading = true
        this.svgUrl = null
        this.svgDownloadFilename = null
        await this.$nextTick()

        try {
          const { data: response } = await createFlowerBouquetSvg(
            {
              month: [...this.selectedMonths],
              autoLayout: this.autoLayout,
              showGuides: this.showGuides,
            },
            this.filename
          )

          const result = response?.data ?? response
          const url = Array.isArray(result) ? result[0]?.url : result?.url

          if (url) {
            this.previewKey += 1
            this.svgUrl = this.withCacheBuster(url)
            this.svgDownloadFilename = (Array.isArray(result) ? result[0]?.filename : result?.filename) || this.filename
          }
        } catch (err) {
          console.error('Birth flower bouquet generation failed:', err)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
